import { Accordion, AccordionHeader } from '@ps/sports-ui-component-library';
import type { MyBet } from '@ps/web-sports-api-types';
import classNames from 'clsx';
import React, { memo } from 'react';

import styles from './Bet.scss';
import SgmPart from './components/Leg/components/SgmPart/SgmPart';
import SgmEventDetails from './components/SgmEventDetails/SgmEventDetails';

export interface Props {
  bet: MyBet;
}

const SgmBet: React.FC<Props> = ({ bet }) => {
  const { isSettled, sgmEvents = [], isSgm, sgmResult } = bet;

  const isBetBuilderPlus = sgmEvents.length > 1;

  return (
    <div className={styles.sgmBet}>
      {sgmEvents.map((event) => (
        <div key={`${event.eventId}-${event.eventDescription}`}>
          <Accordion
            isInitiallyExpanded
            isNested
            variant="light"
            renderTitle={(props) => (
              <AccordionHeader
                {...props}
                title={
                  <SgmEventDetails
                    sgmEvent={event}
                    isSettled={isSettled}
                    sgmResult={sgmResult}
                    isBetBuilderPlus={isBetBuilderPlus}
                  />
                }
              />
            )}
          >
            <div className={classNames(styles.legs, { [styles.sgm]: isSgm })}>
              {event.parts.map((part) => (
                <SgmPart
                  key={`${part.marketId}-${part.eventId}`}
                  part={part}
                  result={part.result}
                />
              ))}
            </div>
          </Accordion>
        </div>
      ))}
    </div>
  );
};

export default memo(SgmBet);
